import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

import { SearchTabs } from "~/components/search-results-page/types";
import { Params } from "~/constants/request";

import { pushHistoryState, replaceHistoryState } from "./history";

export interface updatePageNumberOnSrpProps {
  pageNumber?: number;
  searchParams: URLSearchParams;
  pathname: string;
  router: AppRouterInstance;
}

export const updatePageNumberOnUrl = ({
  pageNumber,
  searchParams,
  pathname,
}: updatePageNumberOnSrpProps) => {
  const currentPage = pageNumber ? pageNumber : 1;
  const shouldHide = currentPage === 1;
  const hash = location.hash || "";

  const query = new URLSearchParams(searchParams);

  if (shouldHide) {
    query.delete(Params.PAGE);
  } else {
    query.set(Params.PAGE, JSON.stringify(currentPage));
  }

  const newParams = `?${query.toString()}${hash}`;
  const newUrl = `${pathname}${newParams}`;

  replaceHistoryState(newParams, { pathname });

  return newUrl;
};

export const updatePageNumberOnSrpArticles = ({
  pageNumber,
  searchParams,
  pathname,
  router,
}: updatePageNumberOnSrpProps): void => {
  const currentPage = pageNumber ? pageNumber : 1;
  const shouldHide = currentPage === 1;
  const hash = location.hash || "";

  const query = new URLSearchParams(searchParams);
  const prevPage = query.get(Params.PAGE);

  query.set(Params.TAB, SearchTabs.ARTICLES);
  if (shouldHide) {
    query.delete(Params.PAGE);
  } else {
    query.set(Params.PAGE, JSON.stringify(currentPage));
  }

  if (!prevPage) {
    const newUrl = `?${query.toString()}${hash}`;
    return router.push(newUrl, { scroll: false });
  }

  pushHistoryState(`${pathname}?${query.toString()}${hash}`, { pathname });
};
